import React, { useEffect, useRef } from "react";
import { useDispatch } from 'react-redux';
import "./dashboard.scss";
import ReactToPrint from "react-to-print";
import ComponentToPrintTheme2 from "./ComponentToPrint";
import { useApiDefaults } from 'hooks/useApiDefaults';
import { getCustomerDetails } from 'redux/actions';

const DashboardTheme2 = ({ customerData }) => {
  const componentRef = useRef();
  const member_number = customerData?.member_number || ""
  const houseChargeEnabled = customerData?.house_charge_enabled === "1"
  const houseChargeAmount = customerData?.house_charge_amount ?? 0
  const apiDefaults = useApiDefaults()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCustomerDetails(apiDefaults));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <div style={{ display: "none" }}>
        <ComponentToPrintTheme2 ref={componentRef} member_number={member_number} />
      </div>

      <div className="dashboard-section-theme2">
        <div className="page-title">
          <h1>My Account</h1>
        </div>
        {customerData && (
          <div className="dashboard-box">
            <div className="first-box">
              <h2>Contact Information</h2>

              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Name: </p>
                </div>
                <div className="text-grid-items">
                  <span>
                    {customerData.first_name + " " + customerData.last_name}
                  </span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Email: </p>
                </div>
                <div className="text-grid-items">
                  <span>{customerData.email_id}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Store: </p>
                </div>
                <div className="text-grid-items">
                  <span>{customerData.ClientStoreName}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Member Number: </p>
                </div>
                <div className="text-grid-items">
                  <span>{member_number}</span>
                </div>
              </div>
              {houseChargeEnabled ? <div className="text-grid">
                <div className="text-grid-items">
                  <p>House Charge: </p>
                </div>
                <div className="text-grid-items">
                  <span>${houseChargeAmount}</span>
                </div>
              </div> : null}

              <div className="text-grid text-block-grid">
                <div className="text-grid-items bg-image" style={{
                  marginLeft: "-28px",width:"450px", height:"116px",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundImage: `url(${customerData ? customerData.barcode_image : ""})`,
                 }}>
                </div>
              </div>

              <ReactToPrint
                trigger={() => (
                  <button style={{minWidth: '120px',
                    height: '44px',
                    borderRadius: '4px',
                    fontSize: '17px',
                    lineHeight: '28px'}}>
                    <i className="fa-solid fa-print"></i>
                    <span> Print Member Number</span>
                  </button>
                )}
                content={() => componentRef.current}
              />
            </div>
          
          </div>
        )}
      </div>
    </>
  );
};
export default DashboardTheme2;
